import {
  Box,
  SpaceBetween,
  StatusIndicator,
} from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

const formatEnum = (value, labels) => labels[value] || `${value ?? 'Unknown'}`;

const formatNumber = (value, suffix = '') => {
  if (typeof value !== 'number') {
    return '--';
  }

  return `${value.toFixed(1)}${suffix}`;
};

const getVacuumFeedbackValues = (value) => {
  if (typeof value !== 'number') {
    return null;
  }

  const mA = 4 + (value / 32767) * 16;
  const vacuumInHg = mA * 3.777 - 45.002;
  const vacuumPercent = (Math.abs(vacuumInHg) / 29.92) * 100;

  return { vacuumInHg, vacuumPercent };
};

const formatVacuumFeedback = (value) => {
  const vacuumValues = getVacuumFeedbackValues(value);
  if (!vacuumValues) {
    return '--';
  }

  const { vacuumInHg, vacuumPercent } = vacuumValues;

  return `${vacuumInHg.toFixed(2)} inHg (${vacuumPercent.toFixed(2)}%)`;
};

const formatDuration = (value) => {
  const totalMilliseconds = Number(value);

  if (!Number.isFinite(totalMilliseconds) || totalMilliseconds < 0) {
    return '--';
  }

  const totalSeconds = Math.floor(totalMilliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

function Value({ label, value }) {
  return (
    <SpaceBetween size="xs">
      <Box variant="awsui-key-label">{label}</Box>
      <div>{value}</div>
    </SpaceBetween>
  );
}

Value.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

function BoolStatus({ label, value = false }) {
  return (
    <Value
      label={label}
      value={(
        <StatusIndicator type={value ? 'success' : 'stopped'}>
          {value ? 'On' : 'Off'}
        </StatusIndicator>
      )}
    />
  );
}

BoolStatus.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
};

export {
  BoolStatus,
  Value,
  formatEnum,
  formatNumber,
  formatDuration,
  formatVacuumFeedback,
  getVacuumFeedbackValues,
};
